import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./Help.scss";
import { utilService } from "../../../../services";
import { HelpData, RespHelpInterface } from "./Help.model";
import { helpService } from "./Help.service";
import NoResults from "../../../../components/Shared/NoResults/NoResultsComponent";
import Loader from "../../../../components/Shared/Loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import { StreamingMedia } from "@ionic-native/streaming-media";

interface HelpProps {
  onCancel: () => void;
}

const Help: React.FC<HelpProps> = (props) => {
  const { t } = useTranslation("settings");
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  var [helpNextValue, setHelpNextValue]: any = useState("");
  const [scrollHeight, setScrollHeight]: [number, Function] = useState(570);

  var [helpData, setHelpData]: any = useState([]);

  useEffect(() => {
    getHelpDetailsToDisplay();
    setInfiniteScrollHeight();
  }, []);

  const setInfiniteScrollHeight = () => {
    const videoGrid: any = document.getElementById("video-grid");
    if (videoGrid) {
      setScrollHeight(videoGrid.clientHeight);
    }
  };

  async function getHelpDetailsToDisplay() {
    setLoaderStatus(true);
    const params: any = getHelpParams();

    const respNotesContainerResult: RespHelpInterface =
      await helpService.getHelpDetails(params);
    if (respNotesContainerResult.isSuccess) {
      setHelpNextValue(respNotesContainerResult.displayHelpContainer[0].next);
      if (pageNo === 1) {
        setHelpData(
          _.cloneDeep(respNotesContainerResult?.displayHelpContainer[0].data)
        );
      } else {
        setHelpData([
          ...helpData,
          ...respNotesContainerResult?.displayHelpContainer[0].data,
        ]);
      }
      setPageNo(pageNo + 1);
    } else {
      console.log("error");
      helpService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const playVideo = (url: string) => {
    StreamingMedia.playVideo(url);
  };

  const getHelpParams = () => {
    return {
      visibility: utilService.isWeb() ? "web" : "mobile",
      reg_code: utilService.getNetwork(),
      page: pageNo,
    };
  };

  const onScroll = () => {
    if (pageNo > 1 && !_.isEmpty(helpNextValue)) {
      getHelpDetailsToDisplay();
    }
  };

  return (
    <div className="help-container">
      <div className="help-back" onClick={props.onCancel}>
        <div className="help-back-icon icon-back"></div>
        <div className="help-back-header">{t("help")}</div>
      </div>
      <div>
        <div className="video-grid" id="video-grid">
          {isLoaderActive && (
            <div className="loader-container">
              <Loader></Loader>
            </div>
          )}
          <InfiniteScroll
            dataLength={helpData.length}
            height={scrollHeight}
            next={() => onScroll()}
            hasMore={true}
            loader={<div></div>}
          >
            <div className="inner-grid image-wrapper">
              <div className="heading">
                {helpData && helpData.length > 0
                  ? helpData.map((item: HelpData, index: number) => {
                      return (
                        <div className="video-wrapper">
                          <div>{item.caption}</div>
                          {utilService.isWeb() && (
                            <video
                              width="100%"
                              poster={
                                // `https://thecallcentral.com/` + commented since data from backend includes the url
                                item.snapshot
                              }
                              src={item.url}
                              controls={true}
                              muted
                              playsInline
                            >
                              <source src={item.url} type="video/mp4" />
                              {t("videoTagNotSupported")}
                            </video>
                          )}
                          {!utilService.isWeb() && (
                            <div
                              className="custom-video-tag"
                              onClick={() => playVideo(item.url)}
                            >
                              <div className="player">
                                <span>{t("play")}</span>
                              </div>
                              <img
                                alt=""
                                className="snapshot"
                                src={
                                  // `https://thecallcentral.com/` +//comment
                                   item.snapshot
                                }
                              ></img>
                            </div>
                          )}
                        </div>
                      );
                    })
                  : [
                      !isLoaderActive && (
                        <span>
                          <NoResults></NoResults>
                        </span>
                      ),
                    ]}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};
export default Help;
